import { FormDocumentMedia } from '../../entities/FormDocumentMedia';

type FormDocumentMediaThumbnailType = Pick<FormDocumentMedia, 'Thumbnail'>;

export class FormDocumentMediaThumbnail implements FormDocumentMediaThumbnailType {
  Thumbnail?: string;

  constructor(record: FormDocumentMedia) {
    this.Thumbnail = record.Thumbnail;
  }
}
